import { render } from "./culturalFb1.vue?vue&type=template&id=516631e4&scoped=true"
import script from "./culturalFb1.vue?vue&type=script&lang=js"
export * from "./culturalFb1.vue?vue&type=script&lang=js"

import "./culturalFb1.vue?vue&type=style&index=0&id=516631e4&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-516631e4"]])

export default __exports__